import React, { memo, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { UserSessionValuesContext } from 'contexts';
import {
  HighlightCard,
  LearningToolsNoteCard,
} from 'components/UserContentCards';
import { EPUB_ANNOTATION_PRESENTATION } from 'constants';
import { areCardsEqual } from 'utilities/sideNavUtils';

const useStyles = makeStyles((theme) => ({
  card: {
    border: 'none',
    borderRadius: '0',
    padding: theme.spacing(0),
  },
}));

const arePropsEqual = (prevProps, nextProps) => {
  const contentItemPropToCompare = ['color', 'userText'];

  return areCardsEqual(prevProps, nextProps, contentItemPropToCompare);
};

const NotesHighlightsListCard = memo(
  ({ contentItem, isSnippetLinkAvailable }) => {
    const classes = useStyles();
    const ref = useRef();

    const { user } = useContext(UserSessionValuesContext);

    const isCollaborationContent = !user.created(contentItem);

    let card;

    if (contentItem.presentation === EPUB_ANNOTATION_PRESENTATION.NOTE) {
      card = (
        <LearningToolsNoteCard
          key={contentItem.id}
          className={classes.card}
          isCollaborationContent={isCollaborationContent}
          userContentItem={contentItem}
          isSnippetLinkAvailable={isSnippetLinkAvailable}
          ref={ref}
        />
      );
    } else if (
      contentItem.presentation === EPUB_ANNOTATION_PRESENTATION.HIGHLIGHT
    ) {
      // don't render collaboration highlights
      if (isCollaborationContent) {
        return null;
      }
      card = (
        <HighlightCard
          key={contentItem.id}
          className={classes.card}
          userContentItem={contentItem}
          isSnippetLinkAvailable={isSnippetLinkAvailable}
          ref={ref}
        />
      );
    }

    return card;
  },
  arePropsEqual,
);

NotesHighlightsListCard.propTypes = {
  contentItem: PropTypes.object.isRequired,
};

export default NotesHighlightsListCard;
